module.exports = __webpack_public_path__ + "static/img/contract0.595bae13.png";